<template>
  <div class="seomain">
    <ul class="tab-tilte four">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

    <!-- 搜索 多行 -->
    <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">待加工</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>加工数量：{{ v.quantity }}</p>
              <p>加工状态：待加工</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/process/info/' + v.id" class="st-opt-btn">备料签收</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">加工中</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>待签收数量：{{ v.total_receiving }}</p>
              <p>加工中：{{ v.total_processing }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/process/info/' + v.id" class="st-opt-btn">备料签收</router-link>
              </div>
              <div class="st-diyr-btn">
                <div class="st-opt-btn" @click="showDialogHeandle(v.id)">
                  完 成
                </div>
                <!-- <router-link :to="'/process/main/' + v.id" class="st-opt-btn">完 成</router-link> -->
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-3">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">已完成</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>完成时间：{{ v.fulfiltime }}</p>
              <p>已完成：{{ v.actual_number }}</p>
              <p>待入库：{{ v.towarehoused }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/process/info/' + v.id + '/false'" class="st-opt-btn">查 看</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 3" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist3" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">已入库</div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.sku }}</p>
              <p>库存编码：{{ v.inventorycode }}</p>
              <p>商品名称：{{ v.products_name }}</p>
              <p>完成时间：{{ v.fulfiltime }}</p>
              <p>已完成：{{ v.actual_number }}</p>
              <p>待入库：{{ v.towarehoused }}</p>
              <p>异常数量：{{ v.total_loss }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/process/info/' + v.id + '/false'" class="st-opt-btn">查 看</router-link>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-dialog v-model="show" show-cancel-button @confirm="onConfirm">
      <div class="mix-detail-box" v-if="dialogData">
        <h2>SKU：{{ dialogData.sku }}</h2>
        <p>商品名称：{{ dialogData.products_name }}</p>
        <p>品牌：{{ dialogData.brand }}</p>
        <p>型号：{{ dialogData.model }}</p>
        <p>配置：{{ dialogData.deploy }}</p>
        <el-input v-model="dialog_num" placeholder="请输入数量"></el-input>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["待加工", "加工中", "已完成", "已入库"],
      cur: 0,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      stlist3: [],
      show: false,
      processActiveId: 0,
      dialog_num: "",
      order_code: "", // 关键字搜索
      sku: "",
    };
  },
  watch: {},
  computed: {
    dialogData() {
      let result = this.stlist1.filter((item) => item.id == this.processActiveId)[0];
      return result;
    },
  },
  methods: {
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.stlist3 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("process_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    // 分页
    async onLoad() {
      let result = await this.$post(this.$api.stGetJiagongList, {
        order_code: this.order_code,
        status: this.cur,
        page: this.page,
        sku: this.sku,
      });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("process_activeIndex", value);
    },
    showDialogHeandle(id) {
      this.show = true;
      this.processActiveId = id;
      this.dialog_num = "";
    },
    async onConfirm() {
      let params = {
        id: this.processActiveId,
        processNum: this.dialog_num,
      };
      console.log(params);
      let result = await this.$post(this.$api.stGetJiaqongDoneEdit, params);
      console.log(result.data);
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "加工" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 220px;
}
/* 2行input  end */

.four li {
  width: 25%;
}
.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #3c8dbc;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
</style>
